import type { GetServerSidePropsContext } from 'next'
import type { ParsedUrlQuery } from 'querystring'
import { paths } from '@mc/paths'
import { SITE_URL } from 'libs/constants'
import { withoutQueryParam, withQueryParam } from 'libs/utils/urls'

const PLAN_PARAM = 'plan'
const PRO_PLAN_VALUE = 'pro'

const isProPlan = (query: ParsedUrlQuery) =>
  query[PLAN_PARAM] === PRO_PLAN_VALUE

// /promotion CTAs only follow their `next` target, so the plan rides inside it.
export const withProPlan = (href: string): string => {
  const url = new URL(href, SITE_URL)
  if (url.pathname !== paths.promotion) {
    return withQueryParam(href, PLAN_PARAM, PRO_PLAN_VALUE)
  }

  const next = url.searchParams.get('next') ?? paths.classRecommendations
  return paths.promotionRedirect(withProPlan(next))
}

export const forwardPlan = (href: string, query: ParsedUrlQuery) =>
  isProPlan(query) ? withProPlan(href) : href

export const withoutPlan = (href: string, query: ParsedUrlQuery) =>
  query[PLAN_PARAM] === undefined ? href : withoutQueryParam(href, PLAN_PARAM)

export const getServerSidePlanParam = (ctx: GetServerSidePropsContext) =>
  isProPlan(ctx.query ?? {}) ? PRO_PLAN_VALUE : null
